/**
 * Shown when the person has no mandate yet: the journey counts from the
 * mandate's start date and keeps its work on the mandate's record, so a new
 * role starts in Mandate's setup.
 */

import { useNavigate } from 'react-router-dom';
import { EmptyState, PrimaryButton } from '../components/primitives';

export default function NoMandate() {
  const navigate = useNavigate();
  return (
    <EmptyState
      title="Your first 100 days start with your mandate"
      hint="Name the role, the organization and your start date. The journey counts from that day and keeps its work on the mandate."
      action={<PrimaryButton onClick={() => navigate('/apps/mandate/setup')}>Set up your mandate</PrimaryButton>}
    />
  );
}
